<template>
    <div class="biaodan">

        <div class="loading"
             v-loading="loading"></div>

        <el-form :model="form"
                 :rules="rules"
                 ref="form"
                 label-width="110px">
            <el-form-item label="用户名/昵称:"
                          prop="nickname"> <el-input type="text"
                          v-model="form.nickname" /> </el-form-item>
            <el-form-item label="手机:"
                          prop="phoneNumber"> <el-input type="text"
                          v-model="form.phoneNumber"
                          maxlength="11" /> </el-form-item>
            <el-form-item label="真实姓名:"
                          prop="identityCardName">
                <div style="display:flex">
                    <el-input type="text"
                              v-model="form.identityCardName"
                              style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>
            <el-form-item label="身份证号:"
                          prop="identityCardNo">
                <div style="display:flex">
                    <el-input type="text"
                              :maxlength="18"
                              v-model="form.identityCardNo"
                              style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>
            <el-form-item label="入住彩种:"
                          prop="lotteryTypes">
                <el-select v-model="form.lotteryTypes"
                           placeholder="请选择"
                           :multiple='true'>
                    <el-option v-for="item in select.arr"
                               :key="item.roleId"
                               :label="item.roleName"
                               :value="item.roleId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="identityCardFront"
                          label="身份证正面">
                <div @click="fileType = 'front'">
                    <el-upload accept="image/jpeg,image/png"
                               action=''
                               :auto-upload="false"
                               :show-file-list="false"
                               :onChange="chooseFile">
                        <el-image v-if="showImg.front"
                                  :src='showImg.front'></el-image>
                        <el-button v-else
                                   type="primary">上传身份证正面</el-button>
                        <b style="margin-left:10px;color:red;">用于提现跟您提供的银行账号和收款二维码比对。</b>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item prop="identityCardBack"
                          label="身份证反面">
                <div @click="fileType = 'bank'">
                    <el-upload accept="image/jpeg,image/png"
                               action=''
                               :auto-upload="false"
                               :show-file-list="false"
                               :onChange="chooseFile">
                        <el-image v-if="showImg.bank"
                                  :src='showImg.bank'></el-image>
                        <el-button v-else
                                   type="primary">上传身份证反面</el-button>
                        <b style="margin-left:10px;color:red;">用于提现跟您提供的银行账号和收款二维码比对。</b>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item label="头像上传:"
                          prop="avatar">
                <div @click="fileType = 'avatar'">
                    <el-upload accept="image/jpeg,image/png"
                               action=''
                               :auto-upload="false"
                               :show-file-list="false"
                               :onChange="chooseFile">
                        <el-image v-if="showImg.avatar"
                                  :src='showImg.avatar'></el-image>
                        <el-button v-else
                                   type="primary">上传头像</el-button>
                    </el-upload>
                </div>
            </el-form-item>

            <!-- ---------------------------------------------------------------- -->

            <el-form-item label="是否有60人以上彩票QQ群,微信群"
                          prop="groupChat"
                          label-width="240px">
                <el-input v-model="form.groupChat"
                          type="text"
                          placeholder="如果没有填无，如果有，说明QQ群号，微信号" />
            </el-form-item>
            <el-form-item label="是否有投注站"
                          prop="bettingShop">
                <el-input v-model="form.bettingShop"
                          type="text"
                          placeholder="如果没有填无，如果有说明投注站信息" />
            </el-form-item>
            <el-form-item label="研究缩水年限"
                          prop="shrinkTime">
                <el-radio-group v-model="form.shrinkTime">
                    <el-radio label="1">两年以内</el-radio>
                    <el-radio label="2">2-5年</el-radio>
                    <el-radio label="3">5-10年</el-radio>
                    <el-radio label="4">10年以上</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="每期大约研究缩水时间" label-width="160px">
                <el-input type="text" v-model="form.meiqiTime"/>
            </el-form-item> -->
            <el-form-item label="qq号"
                          prop="qqNumber">
                <el-input type="text"
                          v-model="form.qqNumber" />
            </el-form-item>
            <el-form-item label="微信号"
                          prop="wechatNumber">
                <el-input type="text"
                          v-model="form.wechatNumber" />
            </el-form-item>
            <el-form-item label="生日"
                          prop="birthday">
                <el-date-picker v-model="form.birthday"
                                type="date"
                                value-format='yyyy-MM-dd'
                                placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="性别"
                          style="paddingBottom:0">
                <el-radio-group v-model="form.gender">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                    <el-radio label="2">保密</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="对缩水师的认识"
                          prop="cognition"
                          label-width="180px">
                <el-input type="textarea"
                          v-model="form.cognition"
                          placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="缩水师最喜欢的座右铭"
                          prop="motto"
                          label-width="180px">
                <div style="display:flex">
                    <el-input type="text"
                              placeholder="用一句话概括"
                              v-model="form.motto" />
                    <el-button type="primary" style="margin-left: 20px;" @click="$refs.popupMotto.init()">选择座右铭</el-button>
					
                </div>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary"
                           @click="submit"
                           :loading="saveBtnLoading">确定</el-button>
            </el-form-item>
        </el-form>

		<motto ref="popupMotto" @confirm="e=>this.form.motto = e"></motto>
		
    </div>
</template>

<script>

import {
    shrinkage_role_list,
    shrinkage_identity,

    shrinkage_register,
} from '@/api/apply'

import { queryUuIdInfo } from '@/api/common'

import motto from '@/components/motto/index.vue'

export default {
	components:{ motto },
    data () {
        return {
            saveBtnLoading: false,

            select: {
                arr: [],
                val: "",
            },

            shrinkage_identity: '',   //可能是用户id

            checkList: ['两年以内'],

            imageUrl: '',

            fileType: '',

            form: {
                id: '',
                nickname: '',        //用户名
                phoneNumber: '',          //手机号
                identityCardName: '',        //真实姓名
                identityCardNo: '',        //身份证好
                lotteryTypes: [],     		//彩种
                identityCardBack: '',          //身份证反面
                identityCardFront: '',          //身份证正面
                avatar: '',          //头像
                groupChat: '',     //受否有60人以上的qq群或者微信群
                bettingShop: '',           //是否是投注站
                shrinkTime: '1',   //研究缩水年限
                // meiqiTime:'',       //每期大约研究缩水时间
                qqNumber: '',           //qq号
                wechatNumber: '',           //微信号
                birthday: '',        //生日
                gender: '0',          //性别
                cognition: '',         //缩水师认识
                motto: '',     //座右铭
                type: 's_shrinkage', 	//对应岗位类型：s_shrinkage：缩水师 ，s_technician：技巧师，s_software：软件师
            },

            showImg: {
                front: '',
                bank: '',
                avatar: '',
            },
            loading: false,


            rules: {
                nickname: { required: true, message: '请输入用户名/昵称', trigger: 'change' },
                phoneNumber: {
                    required: true,
                    message: '请输入有效的中国大陆手机号码',
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        const phonePattern = /^1[3456789]\d{9}$/;
                        if (!phonePattern.test(value)) {
                            callback(new Error('请输入有效的中国大陆手机号码'));
                        } else {
                            callback();
                        }
                    }
                },
                identityCardName: { required: true, message: '请输入真实姓名', trigger: 'change' },
                identityCardNo: {
                    required: true,
                    message: '请输入身份证号',
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        // 基本的身份证号码格式验证
                        const idCardPattern = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;

                        if (!idCardPattern.test(value)) {
                            callback(new Error('请输入正确的身份证号'));
                        } else {
                            // 验证身份证号最后一位校验码
                            if (value.length === 18) {
                                const numArr = value.split('');
                                const factorArr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                                const checkCodeArr = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
                                let sum = 0;

                                for (let i = 0; i < 17; i++) {
                                    sum += parseInt(numArr[i]) * factorArr[i];
                                }

                                const remainder = sum % 11;
                                if (numArr[17].toUpperCase() !== checkCodeArr[remainder]) {
                                    callback(new Error('请输入正确的身份证号'));
                                } else {
                                    callback();
                                }
                            } else {
                                callback();
                            }
                        }
                    }
                },
                lotteryTypes: { required: true, message: '请选择彩种', trigger: ['change', 'blur'] },

                identityCardFront: { required: true, message: '请上传正面', trigger: 'change' },
                identityCardBack: { required: true, message: '请上传反面', trigger: 'change' },
                avatar: { required: true, message: '请上传头像', trigger: 'change' },

                groupChat: { required: true, message: '是否有60人以上的qq群或者微信群', trigger: 'change' },
                bettingShop: { required: true, message: '是否是投注站', trigger: 'change' },
                qqNumber: { required: true, message: 'qq号', trigger: 'change' },
                wechatNumber: { required: true, message: '微信号', trigger: 'change' },
                birthday: { required: true, message: '生日', trigger: 'change' },
                cognition: { required: true, message: '缩水师认识', trigger: 'change' },
                motto: { required: true, message: '座右铭', trigger: 'change' },

            },

        };
    },

    mounted () {
        // 获取缩水师对应的角色列表
        shrinkage_role_list().then(res => this.select.arr = res.data)

        // 获取当前登录用户信息
        // shrinkage_identity().then(res=> this.shrinkage_identity = res.data.id)

        queryUuIdInfo().then(res => this.form.id = res)
    },

    methods: {
		// mottoConfirm(){
		// 	this.popupMotto.show = false
		// 	this.form.motto = this.popupMotto.motto[this.popupMotto.active]
		// },

        chooseFile (e) {

            let fileType_number = this.fileType == 'front' ? 'id_card_front' :
                this.fileType == 'bank' ? 'id_card_back' :
                    this.fileType == 'avatar' ? 'avatar' : ''

            const data = { file: e.raw };

            // console.log('aaa', data);
            let params = `?fileType=${fileType_number}&bizId=${this.form.id}&number=${fileType_number}`

            this.loading = true

            // console.log(this.$utils.upLoadFile);
            this.$utils.upLoadFile(params, data).then(res => {

                this.fileType == 'front' ? this.form.identityCardFront = res.data.urls : ''
                this.fileType == 'bank' ? this.form.identityCardBack = res.data.urls : ''
                this.fileType == 'avatar' ? this.form.avatar = res.data.urls : ''

                this.showImg[this.fileType] = this.$utils.fileToBolb(e.raw)

                if (this.fileType == 'front') {
                    // 手动控制去除某个字段的错误信息  （gpt:清除该字段的错误信息）
                    // this.$refs.form.clearValidate('identityCardFront');


                    let field = 'identityCardFront'
                    // 手动检测特定字段的有效性
                    this.$refs.form.validateField(field, (errorMsg) => {
                        // 如果 errorMsg 为空字符串，表示字段有效
                        if (errorMsg === '') {
                            console.log(`${field} 字段有效`);
                        } else {
                            console.log(`${field} 字段无效，错误消息：${errorMsg}`);
                        }
                    });


                }
                if (this.fileType == 'bank') {
                    // 手动控制去除某个字段的错误信息  （gpt:清除该字段的错误信息）
                    // this.$refs.form.clearValidate('identityCardBack');

                    // 手动检测特定字段的有效性  （尝试-简写-可以的）
                    this.$refs.form.validateField('identityCardBack');
                }
                if (this.fileType == 'avatar') {
                    // 手动检测特定字段的有效性  （尝试-简写-可以的）
                    this.$refs.form.validateField('avatar');
                }

                this.loading = false
            }).catch(err => {
                console.log('err', err);
                this.loading = false
            })
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.saveBtnLoading = true

                    shrinkage_register(this.form).then(res => {
                        this.loading = false
                        this.saveBtnLoading = false
                        if (res.code == 200) {
                            this.$message.success('申请成功，请耐性等待1-5个工作日')
                            this.resetForm()
                            //
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        resetForm () {
            this.showImg = {
                front: '',
                bank: '',
                avatar: '',
            }

            // for (let i in this.form) {
            //     this.form[i] = ''
            // }

            queryUuIdInfo().then(res => this.form.id = res)
            this.$refs.form.resetFields();
        }
    }
};
</script>

<style lang="scss" scoped>

.biaodan {
    position: relative;
    .loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
}
.el-image {
    height: 150px;
}
.idCardUpload {
    display: flex;
    font-size: 30px;
    color: rgba(0, 0, 0, 0.2);
    > div {
        border: 1px solid rgba(0, 0, 0, 0.1);
        height: 150px;
        line-height: 150px;
        width: 300px;
        text-align: center;
        margin-right: 20px;
    }
}
.el-form-item {
    margin-bottom: 11px;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 11px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.form {
    border: 1px solid rgba(0, 0, 0, 0.2);
    > div {
        padding: 10px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        .el-input {
            width: 160px;
            margin-right: 10px;
        }
        > span {
            &.require {
                &::before {
                    content: '* ';
                    color: red;
                }
            }
            &:nth-child(1) {
                display: inline-block;
                min-width: 130px;
                text-align: right;
                margin-right: 10px;
            }
        }
        .msg {
            color: #a16222;
            font-size: 15px;
        }
    }
}
</style>
